module.exports = __webpack_public_path__ + "static/media/phone.9bae5324.svg";